import React, { useState } from "react"
import styled, { css } from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"
import { CopyToClipboard } from "react-copy-to-clipboard"

import Icon from "../global/icon"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const CardWrapper = styled.div`
  // margin: 0 0 48px;
  min-width: 380px;
  background-color: white;
  box-shadow: 0px 1px 16px 2px rgba(117, 128, 143, 0.1);
  border-radius: 4px;
  overflow: hidden;
  ${below.tablet`
   width: 100%;
  //  margin: 0 0 32px;
    min-width:unset;
    `};
`
const Teammate = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 24px 48px 16px;
  border-bottom: 1px solid #e2e8f0;
  ${below.tablet`padding: 16px 24px;`}
  ${below.mobile`
  flex-direction:column;
  `}
`
const HeadshotWrapper = styled.div`
  margin-right: 32px;
  min-width: 136px;
  min-height: 136px;
  img {
    border: 5px solid hsla(0, 0%, 77%, 0.65);
    border-radius: 50%;
  }

  ${below.mobile`
    min-width: 80px; 
  min-height: 80px; 
  margin-right:0;
  margin-bottom:10px;
  `}
`
const ContactInfo = styled(motion.div)`
  padding: 0 48px;
  outline: none;
  svg {
    fill: #75808f;
  }
  ul {
    margin-bottom: 16px;
    :last-of-type {
      margin-bottom: 36px;
    }
    /* ${below.tablet`margin: 8px 0;`} */
    div {
      font-size: 12px;
      line-height: 16px;
      color: var(--grey);
    }
    .phone button {
      color: var(--pacific-blue);
    }
    li {
      font-size: 16px;
      line-height: 20px;
      color: var(--alt-black);
      padding-left: 0px;
      &.nmls {
        color: var(--grey);
      }
      button {
        cursor: pointer;
        font-size: 16px;
        line-height: 20px;
        color: var(--alt-black);
        padding-left: 0px;
        background: transparent;
        border: none;
      }
      ::before {
        display: none;
      }
    }
  }
`
const Name = styled.h3`
  ${below.mobile`
 
   text-align:center;
   `}
`
const Title = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: var(--grey);
  ${below.mobile`
text-align:center;
  `}
`
const Expand = styled.button`
  background-color: transparent;
  border: none;
  width: 100%;
  height: 56px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  /* ${below.tablet`height: 32px;`} */
  svg {
    width: 16px;
    height: 16px;
    margin-top: 2px;
  }
  span {
    display: flex;
    font-size: 16px;
    line-height: 20px;
    color: var(--alt-black);
    transition: 0.3s ease-in-out;
    :hover {
      text-decoration: underline;
      color: var(--pacific-blue);
    }
    :last-child {
      padding: 0 12px;
    }
  }
`
const CopyEmail = styled.button`
  background-color: transparent;
  cursor: pointer;
  border: none;
  width: 100%;
  font-size: 16px;
  line-height: 20px;
  color: var(--pacific-blue);
  text-align: center;
  margin-bottom: 16px;
`
const Headless = styled.div`
  display: block;
  margin: 0;
  min-width: 136px;
  min-height: 136px;
  border-radius: 50%;
  background-color: #264765;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 900;
  font-size: 64px;
  line-height: 64px;
  ${below.mobile`
  min-width: 80px;
   min-height: 80px;
    margin-right: 24px;
     font-size: 48px;
      lineheight: 48px;`}
`

const TeamCard = props => {
  const [isExpanded, setExpanded] = useState(false)
  const [isCopied, setCopied] = useState(false)
  return (
    <CardWrapper>
      <Teammate>
        <HeadshotWrapper>
          {props.headshot ? (
            <GatsbyImage
              image={props.headshot.gatsbyImageData}
              alt={`${props.fullname}, Atlantic Bay ${props.title}`}
            />
          ) : (
            <Headless>{`${props.fullname
              .split(" ")
              .map(n => n[0])
              .join("")}`}</Headless>
          )}
        </HeadshotWrapper>
        <div>
          <Name>{props.fullname}</Name>
          <Title>{props.title}</Title>
          {props.nmls && <Title className="nmls">NMLS #{props.nmls}</Title>}
        </div>
      </Teammate>
      <Expand
        onClick={() => {
          setExpanded(!isExpanded)
          setCopied(false)
        }}
      >
        <span>Get in touch with me</span>
        <span>
          <Icon
            icon={isExpanded ? "closeDrawer" : "openDrawer"}
            width="12"
            height="12"
          />
        </span>
      </Expand>

      <ContactInfo
        initial={{ height: "0px" }}
        animate={{
          height: !isExpanded ? "0px" : "auto",
        }}
      >
        {props.email && (
          <ul>
            <div>Email</div>
            <CopyToClipboard text={props.email}>
              <li className="phone">
                <button onClick={() => setCopied(true)}>{props.email}</button>
              </li>
            </CopyToClipboard>
          </ul>
        )}
        {props.phone && (
          <ul>
            <div>Phone</div>
            <li>{props.phone}</li>
          </ul>
        )}
        <CopyToClipboard text={props.email}>
          <CopyEmail onClick={() => setCopied(true)}>
            {!isCopied ? "Copy email" : "Email copied"}
          </CopyEmail>
        </CopyToClipboard>
      </ContactInfo>
    </CardWrapper>
  )
}

export default TeamCard
